import Router from "./router";
import { AppProvider } from "./context/AppContext";
import AuthInterceptor from "./ApiService/AuthInterceptor";

function App() {
  return (
    <AppProvider>
      <AuthInterceptor />
      <Router />
    </AppProvider>
  );
}

export default App;



// import Router from "./router";
// import { AppProvider } from "./context/AppContext";

// function App() {
//   return (
//     <AppProvider>
//       <Router />
//     </AppProvider>
//   );
// }

// export default App;
